module.exports = __webpack_public_path__ + "img/rectangle-landscape.svg";